// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__2V2s6","title":"BackImages_title__3Tp8h","images":"BackImages_images__2Xrec"};